import { BusIcon } from "assets/icons";

function BookingCard({ item }) {
  return (
    <div className="w-full max-w-[490px] bg-white shadow-block p-4 md:p-5 flex flex-col rounded-[15px]">
      <div className="flex items-center gap-4 mb-3">
        <div
          className="bgImage !h-[46px] !w-[46px] rounded-full"
          style={{
            backgroundImage: `url(${process.env.REACT_APP_BASE_URL}/${item.bus_img})`,
          }}
        />
        <div className="flex flex-col">
          <div className="text-base md:text-lg md:leading-6 font-semibold text-black">
            {item.bus_no}
          </div>
          <div className="text-sm md:text-lg md:leading-6 font-medium text-[#858585]">
            AC Seater
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-[#1D1D1D] text-[12px] leading-4 md:text-base md:leading-6 font-medium">
            {item.boarding_city}
          </div>
          <div className="text-primary-700 text-sm md:text-base font-medium">
            {item.bus_picktime}
          </div>
        </div>
        <div className="flex flex-col gap-1.5 md:gap-2">
          <div className="flex flex-col items-center justify-center">
            <div className="w-12 border-[1px] border-dashed border-primary-700 z-0" />
            <div className="bg-white px-1.5 text-primary-700 -mt-2 z-[1]">
              <BusIcon />
            </div>
          </div>
          <div className="text-[#858585] text-sm md:text-base">
            {item.Difference_pick_drop}
          </div>
        </div>
        <div className="flex flex-col">
          <div className="text-[#1D1D1D] text-[12px] leading-4 md:text-base md:leading-6 font-medium">
            {item.drop_city}
          </div>
          <div className="text-primary-700 text-sm md:text-base font-medium">
            {item.bus_droptime}
          </div>
        </div>
      </div>
    </div>
  );
}
export default BookingCard;
